import { commitLocalUpdate } from 'react-relay';

import { get } from 'lodash';
import { put } from 'redux-saga/effects';
import { RecordProxy } from 'relay-runtime';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import { updateFetchKeyDelayed } from '@lib/actions';
import { FetchKeysStoreKey } from '@lib/reducers/createFetchKeysReducer';
import environment from '@lib/utils/RelayEnvironment';

import { toGlobalId } from 'services/relayService';

export default function* sagaRelayInvalidateData(type: FetchKeysStoreKey, data?: any) {
  let record: RecordProxy | null | undefined;
  try {
    commitLocalUpdate(environment, (store) => {
      try {
        const _id = get(data, '_id');
        const globalId = _id && toGlobalId(type, _id);
        record = globalId ? store.get(globalId) : undefined;
        if (record) {
          // TODO: Update the record directly on the store instead of refetching
          // NOTE: We better get all necessary info from the socket event or rather fetch lookups here?

          // TODO: Invalidate single record so only queries containing this record will be stale
          // Not done yet b/c we need to refresh queries for chat in case the assignee changes
          // record.invalidateRecord();
          // @ts-ignore
          store.invalidateStore();
        } else {
          // @ts-ignore
          store.invalidateStore();
        }
      } catch (error) {
        sendLog(`sagaRelayInvalidateData`, { error, type, data }, LoggerStatusEnum.error);
      }
    });
    if (!record) {
      // Update the `fetchKey` to force refresh on queries that are listening to it
      // In case a query doesn't have any invalidated record, it will get the data from the store and skip the network call
      yield put(updateFetchKeyDelayed(type));
    }
  } catch (error) {
    sendLog(`sagaRelayInvalidateData`, { error, type, data }, LoggerStatusEnum.error);
  }
  return record;
}
